import { render, staticRenderFns } from "./BestsellAll.vue?vue&type=template&id=788b48bb&scoped=true&"
import script from "./BestsellAll.vue?vue&type=script&lang=js&"
export * from "./BestsellAll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788b48bb",
  null
  
)

export default component.exports